// frontend/src/auth/guest.ts
// W1-B („Zwei Einstiege") — eine einzige Stelle, die beantwortet, ob das
// aktuelle Konto ein GASTKONTO ist.
//
// Wichtig zur Begriffsklaerung: der AuthProvider-Status 'anonymous' bedeutet
// „gar nicht angemeldet". Ein Gast ist demgegenueber vollwertig angemeldet
// (Status 'authed') und hat nur kein registriertes Konto. Beides sauber zu
// trennen war der Grund, den frueheren Status-Bezeichner 'guest' umzubenennen.

import type { AuthUser } from '../api/types';

/**
 * true, sobald der Server das Konto als Gastkonto meldet (users.is_guest).
 * SQLite liefert Boolean-Spalten je nach Route als 0/1 oder als echtes
 * Boolean — beide Formen werden hier bewusst akzeptiert.
 */
export function isGuestUser(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  const raw: unknown = user.is_guest;
  return raw === true || raw === 1 || raw === '1';
}
